import { initial } from 'lodash';
import { Theme } from 'styles/theme';

export const editAdminSelectStyles = {
  menu: (styles: any) => ({ ...styles }),
  control: (styles: any) => ({
    ...styles,
    borderColor: 'gray',
    fontSize: '14px',
    lineHeight: '17px',
    borderRadius: '3px',
    boxShadow: 'none !important',
    color: '#222',
    margin: 0,
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    fontSize: '100%',
  }),
};

export const registerCompanySelectStyles = (theme: Theme) => {
  return {
    placeholder: (baseStyles: any) => ({
      ...baseStyles,
      fontFamily: theme.fontFamilies.body,
      fontSize: `${theme.fontSizes.small}rem`,
      color: theme.colors.primaryBlack70,
      padding: '1rem 1rem 1rem 0',
      margin: 0,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      boxShadow: 'none',
      fontSize: `${theme.fontSizes.small}rem`,
      border: '1px solid gray',
      borderRadius: 0,
      outline: state.isFocused ? `-webkit-focus-ring-color auto 1px;` : 'none',
      minHeight: '51px',
      paddingLeft: '1rem',
      transition: 'none',
      '&:hover': {
        borderColor: initial, // Prevent border change on hover
      },
    }),
    option: (baseStyles: any) => ({
      ...baseStyles,
      height: '30px',
    }),
    indicatorSeparator: (styles: any) => ({ ...styles, display: 'none' }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      paddingRight: '1rem',
    }),
    singleValue: (styles: any) => ({ ...styles, padding: '1rem 1rem 1rem 0', margin: 0 }),
    multiValue: (styles: any) => ({
      ...styles,
      '> div:first-child': {
        fontSize: '100%',
      },
    }),
    valueContainer: (styles: any) => ({ ...styles, padding: 0, margin: 0 }),
    input: (styles: any) => ({ ...styles, padding: 0, margin: 0 }),
  };
};
